import { useState } from 'react';
import useClient from 'api/client';
import { useAlert } from 'components/message/AlertContext';
import { NewEnvironmentInput } from 'types/Environment';
import createEnvironment from 'api/Environment/createEnvironment';
import { isValidCombinedLength } from './ValidateLabelAndGroups';

export default function useCreateEnvironment() {
    const client = useClient();
    const { openAlert } = useAlert();
    const [createLoading, setCreateLoading] = useState(false);

    const handleCreate = async (formData: NewEnvironmentInput) => {
        setCreateLoading(true);
        try {
            const validations = [
                isValidCombinedLength(
                    46,
                    formData.label,
                    formData.SamlGroupName,
                ),
                isValidCombinedLength(
                    46,
                    formData.label,
                    formData.SamlFullDevGroupName,
                ),
                isValidCombinedLength(
                    46,
                    formData.label,
                    formData.SamlBasicDevGroupName,
                ),
                isValidCombinedLength(
                    46,
                    formData.label,
                    formData.SamlReaderGroupName,
                ),
            ];

            if (validations.some((validation) => !validation)) {
                openAlert({
                    message: `The combined length of the label and the group names should not exceed 46 characters`,
                    severity: 'alert',
                });
                setCreateLoading(false);
                return;
            }

            const response = await client.mutate(createEnvironment(formData));

            if (!response.errors) {
                openAlert({
                    message: `Succesfully created environment`,
                    severity: 'success',
                    path: `/environment/${response.data.createEnvironment.environmentUri}`,
                });
            } else {
                // TODO: error messages are not redable for users here, we should map them and create redable translations
                openAlert({
                    message: `Something went wrong... Could not create environment, received ${response.errors[0]?.message}`,
                    severity: 'alert',
                });
            }
        } finally {
            setCreateLoading(false);
        }
    };

    return {
        handleCreate,
        createLoading,
    };
}
